// extracted by mini-css-extract-plugin
export var fullWidthButton = "_qj-0";